export default {
  MENU: {
    TEACHER: [
      {
        id: "CO-HOME",
        label: "Home",
        icon: require("@/assets/img/svg/home.svg"),
        css: "home",
        dashBoardBGColor: "",
        toRoute: "home",
        hideFromDashBoard: true,
        sub_menus: [
          {
            text: "Notifications",
            toRoute: "notification-inbox"
          },
          { text: "Tests", toRoute: "assign-tests" },
          { text: "Result Analysis", toRoute: "test-results" },
          { text: "Customization", toRoute: "profile", hideFromDrawer: true }
        ]
      },
      {
        label: "Notifications",
        id: "CO-NOTI",
        icon: require("@/assets/img/svg/notification.svg"),
        dashBoardIcon: require("@/assets/img/svg/notification.svg"),
        css: "notification",
        dashBoardBGColor: "notification-icon",
        toRoute: "notification-inbox",
        sub_menus: [
          { text: "Inbox", type: "inbox", toRoute: "notification-inbox" },
          // { text: "Sent Items", toRoute: "notification-sent" }
          { text: "Attendance", toRoute: "attendance-list", sub_pages: ["mark-attendance"] }
        ]
      },
      {
        label: "Tests",
        id: "CO-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        toRoute: "assign-tests",
        dashBoardBGColor: "tests-icon",
        sub_menus: [
          {
            text: "Assigned Tests",
            toRoute: "assign-tests"
          },

          { text: "Past Tests", toRoute: "past-tests-teacher" }
        ]
      },
      {
        label: "Result Analysis",
        id: "CO-RESULT-ANALYSIS",
        icon: require("@/assets/img/svg/result_analysis.svg"),
        dashBoardIcon: require("@/assets/img/svg/result_analysis.svg"),
        css: "result_analysis",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "test-results",
        sub_menus: [
          { text: "Test Results", toRoute: "test-results" },
          {
            text: "Studentwise Analysis",
            toRoute: "monitor-students",
            sub_pages: [
              "testwise-analysis-coordinator",
              "cumulative-analysis-coordinator",
              "response-analysis",
              "response-analysis-coordinator",
            ]
          },
          { text: "Batch Health", toRoute: "batch-health" }
        ]
      },
      {
        label: "Customization",
        id: "ST-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        sub_menus: [
          // {
          //   text: "Edit Photo",
          //   toRoute: "profile",
          //   hideFromDrawer: true,
          //   hideFromBreadCrumb: true
          // },
          // { text: "Edit Info", toRoute: "profile", hideFromDrawer: true },
          {
            text: "Personal Profile",
            toRoute: "profile",
            hideFromDashBoard: false
          },
          { text: "Institute Questions", toRoute: "personal-questions" },
          { text: "Bookmarked Questions", toRoute: "bookmark-questions" },
        ]
      }
    ],

    DEO: [
      {
        id: "CO-HOME",
        label: "Home",
        icon: require("@/assets/img/svg/home.svg"),
        css: "home",
        dashBoardBGColor: "",
        toRoute: "home",
        hideFromDashBoard: true,
        sub_menus: [
          {
            text: "Notifications",
            toRoute: "notification-inbox",
            hideFromBreadCrumb: true
          },
          { text: "Tests", toRoute: "customized-tests" },
          { text: "Customization", toRoute: "profile" }
        ]
      },
      {
        label: "Notifications",
        id: "CO-NOTI",
        icon: require("@/assets/img/svg/notification.svg"),
        dashBoardIcon: require("@/assets/img/svg/notification.svg"),
        css: "notification",
        dashBoardBGColor: "notification-icon",
        toRoute: "notification-inbox",
        sub_menus: [
          { text: "Inbox", type: "inbox", toRoute: "notification-inbox" },
          // { text: "Sent Items", toRoute: "notification-sent" }
          { text: "Attendance", toRoute: "attendance-list", sub_pages: ["mark-attendance"] },
          { text: "Timetable", toRoute: "timetable-list" }
        ]
      },
      {
        label: "Tests",
        id: "CO-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        toRoute: "customized-tests",
        dashBoardBGColor: "tests-icon",
        sub_menus: [
          {
            id: 9,
            text: "Customized Tests",
            toRoute: "customized-tests",
            sub_pages: ["create-customized-tests"],
            hideFromDrawer: false,
            hideFromBreadCrumb: false
          },
          {
            text: "Past Tests",
            toRoute: "past-test-institute",
            // sub_pages: ["create-customized-tests"],
            hideFromDrawer: false,
            hideFromBreadCrumb: false
          
          },
          {
            text: "Scheduled Tests",
            toRoute: "schedule-tests"
          }
        ]
      },
      {
        label: "Customization",
        id: "ST-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        sub_menus: [
          // {
          //   text: "Edit Photo",
          //   toRoute: "profile",
          //   hideFromDrawer: true,
          //   hideFromBreadCrumb: true
          // },
          // { text: "Edit Info", toRoute: "profile", hideFromDrawer: true },
          {
            text: "Personal Profile",
            toRoute: "profile",
            hideFromDashBoard: false
          },
          { text: "Institute Questions", toRoute: "personal-questions" },
          { text: "Bookmarked Questions", toRoute: "bookmark-questions" },
        ]
      }
    ],
    COORDINATOR: [
      {
        id: "CO-HOME",
        label: "Home",
        icon: require("@/assets/img/svg/home.svg"),
        css: "home",
        dashBoardBGColor: "",
        toRoute: "home",
        hideFromDashBoard: true,
        sub_menus: [
          {
            text: "Notifications",
            toRoute: "notification-inbox",
            hideFromBreadCrumb: true
          },
          { text: "Batches", toRoute: "create-batch" },
          { text: "Users", toRoute: "add-users" },
          { text: "Result Analysis", toRoute: "test-results" },
          { text: "Tests", toRoute: "customized-tests" },
          {  text: "Customization", toRoute: "profile" }
        ]
      },
      {
        label: "Notifications",
        id: "CO-NOTI",
        icon: require("@/assets/img/svg/notification.svg"),
        dashBoardIcon: require("@/assets/img/svg/notification.svg"),
        css: "notification",
        dashBoardBGColor: "notification-icon",
        toRoute: "notification-inbox",
        sub_menus: [
          { text: "Inbox", type: "inbox", toRoute: "notification-inbox" },
          // { text: "Sent Items", toRoute: "notification-sent" }
          { text: "Attendance", toRoute: "attendance-list", sub_pages: ["mark-attendance"] },
          { text: "Timetable", toRoute: "timetable-list" }
        ]
      },
      {
        id: "CO-BATCH",
        label: "Batches",
        icon: require("@/assets/img/svg/batches.svg"),
        dashBoardIcon: require("@/assets/img/svg/batches.svg"),
        css: "batches",
        dashBoardBGColor: "batches-icon",
        toRoute: "create-batch",
        sub_menus: [
          { text: "Create Batches", toRoute: "create-batch" },
          { text: "Manage Batches", toRoute: "manage-batches" }
        ]
      },
      {
        label: "Users",
        id: "CO-USER",
        icon: require("@/assets/img/svg/users.svg"),
        dashBoardIcon: require("@/assets/img/svg/users.svg"),
        css: "users",
        dashBoardBGColor: "users-icon",
        toRoute: "add-users",
        sub_menus: [
          { text: "Add Users", toRoute: "add-users" },
          { text: "Approve Users", toRoute: "approve-users" },
          { text: "Manage Users", toRoute: "manage-users" },
          // { text: 'Batch Allocation', toRoute: 'batch-allocation' },
          {
            text: "Monitor Students",
            toRoute: "students-anaylsis",
            sub_pages: [
              "testwise-analysis-director",
              "cumulative-analysis-director",
              "response-analysis-director"
            ]
          }
          // { text: 'Edit Users', toRoute: 'edit-users' }
        ]
      },
      {
        label: "Customization",
        id: "CO-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        sub_menus: [
          /*{
            text: "Edit Photo",
            toRoute: "profile",
            hideFromDrawer: true,
            hideFromBreadCrumb: true,
          },*/
          //{ text: "Edit Info", toRoute: "profile", hideFromDrawer: true },
          /*{
            text: "Notifications",
            toRoute: "notification-inbox",
            hideFromDashBoard: true,
          },
          { text: "Batches", toRoute: "create-batch", hideFromDashBoard: true },
          { text: "Users", toRoute: "add-users", hideFromDashBoard: true },
          {
            text: "Result Analysis",
            toRoute: "test-results",
            hideFromDashBoard: true,
          },
          {
            text: "Tests",
            toRoute: "complimentary-test",
            hideFromDashBoard: true,
          },*/
          { text: "Personal Profile", toRoute: "profile" },
          {
            text: "Subscription Details",
            toRoute: "subscription-details",
            sub_pages: ["renew-subscription", "purchase-subscription"],
            hideFromDashBoard: false,
            hideFromDrawer: false
          },
          { text: "Institute Questions", toRoute: "personal-questions" },
          { text: "Bookmarked Questions", toRoute: "bookmark-questions" },
        ]
      },
      {
        label: "Tests",
        id: "CO-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        toRoute: "customized-tests",
        dashBoardBGColor: "tests-icon",
        sub_menus: [
          // {
          //   text: "Proficiency Tests",
          //   toRoute: "complimentary-test",
          //   hideFromDrawer: false,
          //   hideFromBreadCrumb: false,
          //   hideFromDashBoard: false
          // },
          {
            id: 9,
            text: "Customized Tests",
            toRoute: "customized-tests",
            sub_pages: ["create-customized-tests"],
            hideFromDrawer: false,
            hideFromBreadCrumb: false,
            hideFromDashBoard: false
          },
           {
            text: "AITS Tests",
            toRoute: "aits-test",
            hideFromDrawer: false,
            hideFromBreadCrumb: false
          },
          {
            text: "Past Tests",
            toRoute: "past-test-institute",
            // sub_pages: ["create-customized-tests"],
            hideFromDrawer: false,
            hideFromBreadCrumb: false
            
          },
          {
            text: "Scheduled Tests",
            toRoute: "schedule-tests",
            hideFromDrawer: false
          },
          // {
          //   id: 5,
          //   text: "All India Test Series",
          //   toRoute: "all-india-test-series",
          //   hideFromDrawer: false,
          //   hideFromBreadCrumb: false,
          //   hideFromDashBoard: false
          // }, //UI pending
        ]
      },
      {
        label: "Result Analysis",
        id: "CO-RESULT-ANALYSIS",
        icon: require("@/assets/img/svg/result_analysis.svg"),
        dashBoardIcon: require("@/assets/img/svg/result_analysis.svg"),
        css: "result_analysis",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "test-results",
        sub_menus: [
          { text: "Test Results", toRoute: "test-results" },
          {
            text: "Studentwise Analysis",
            toRoute: "monitor-students",
            sub_pages: [
              "testwise-analysis-coordinator",
              "cumulative-analysis-coordinator",
              "response-analysis-coordinator"
            ]
          },
          { text: "Batch Health", toRoute: "batch-health-old" }
        ]
      }
    ],
    STUDENT: [
      {
        label: "Home",
        id: "ST-HOME",
        name: "ST-HOME",
        icon: require("@/assets/img/svg/home.svg"),
        dashBoardIcon: require("@/assets/img/svg/home.svg"),
        css: "home",
        dashBoardBGColor: "",
        hideFromDashBoard: true,
        toRoute: "home",
        sub_menus: [
          { text: "Notifications", toRoute: "notification-inbox" },
          { text: "Tests", toRoute: "live-test" },
          { name: "ST-BOOST-UP", text: "Boost Up", toRoute: "make-your-test", fallbackRoute: "improvement-assignments", conditionalBoostUpRoute: true },
          { text: "Health", toRoute: "my-health" },
          { text: "Result & Reports", toRoute: "testwise-analysis" },
          {
            // id: "ST-UPGRADE",
            text: "Upgrade Membership",
            toRoute: "my-subscription",
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
            hideFromDashBoard:true, hideFromDrawer:true,hideFromInstitute:true
          }
        ]
      },
      {
        label: "Notifications",
        id: "ST-NOTI",
        name: "ST-NOTI",
        icon: require("@/assets/img/svg/notification.svg"),
        dashBoardIcon: require("@/assets/img/svg/notification.svg"),
        css: "notification",
        dashBoardBGColor: "notification-icon",
        toRoute: "notification-inbox",
        sub_menus: [
          { text: "Inbox", toRoute: "notification-inbox" },
          // { text: "Sent Items", toRoute: "notification-sent" }
        ]
      },
      {
        label: "Tests",
        id: "ST-TEST",
        name: "ST-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        dashBoardBGColor: "tests-icon",
        toRoute: "live-test",
        sub_menus: [
          { text: "Live Tests", toRoute: "live-test" },
          { text: "Upcoming Tests", toRoute: "upcoming-test" },
          {
            // id: "READY-MADE-TEST",
            text: "Ready-made Tests",
            toRoute: "ready-made-test",
            hideFromDashBoard:true, hideFromDrawer:true,hideFromInstitute:true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

          },
          // { text: "Premium Tests", toRoute: "premium-test" },
          { text: "Past Tests", toRoute: "past-test" },
          {
            name: "ATTEMPTED QUESTIONS",
            text: "Attempted Questions",
            toRoute: "attempted-questions"
          }
        ]
      },
      {
        label: "Boost Up",
        id: "ST-BOOST-UP",
        name: "ST-BOOST-UP",
        icon: require("@/assets/img/svg/boost-icon.svg"),
        dashBoardIcon: require("@/assets/img/svg/boost-icon.svg"),
        css: "boost",
        dashBoardBGColor: "boost-icon",
        toRoute: "make-your-test",
        requiresBoostUpModule: true,
        sub_menus: [
          {
            id: 10,
            text: "Make Your Test",
            toRoute: "make-your-test",
            fallbackRoute: "improvement-assignments",
            fallbackText: "A(I)ssignments",
            conditionalBoostUpRoute: true,
            sub_pages: ["create-MYT-tests"],
            hideFromDashBoard:true, hideFromDrawer:true,
            requiresBoostUpModule: true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
          },
          {
            text: "A(I)ssignments",
            toRoute: "improvement-assignments"
          },

          {
            id: 10,
            text: "Practice Session",
            toRoute: "practice-session",
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
            hideFromDashBoard:true, hideFromDrawer:true,
            requiresBoostUpModule: true
          },
          { text: "Bookmarked Questions", toRoute: "bookmarked-questions" }
        ]
      },
      {
        label: "Health",
        id: "ST-HEALTH",
        name: "ST-HEALTH",
        icon: require("@/assets/img/svg/add.svg"),
        dashBoardIcon: require("@/assets/img/svg/add.svg"),
        css: "health",
        dashBoardBGColor: "health-icon",
        toRoute: "my-health",
        sub_menus: [
          {
            text: "My Health",
            toRoute: "my-health",
            sub_pages: ["chapters-health", "topic-health"]
          },
          { text: "Leaderboard", toRoute: "leaderboard" }
        ]
      },
      {
        label: "Result & Reports",
        id: "ST-RESULT-ANALYSIS",
        name: "ST-RESULT-ANALYSIS",
        icon: require("@/assets/img/svg/result_analysis.svg"),
        dashBoardIcon: require("@/assets/img/svg/result_analysis.svg"),
        css: "result_analysis",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "testwise-analysis",
        sub_menus: [
          {
            text: "Test Results",
            toRoute: "testwise-analysis",
            sub_pages: ["response-analysis-coordinator"]
          },
          { text: "Cumulative Results", toRoute: "cumulative-analysis" },
          { name: "TEST-REPORT", text: "Test Reports", toRoute: "test-reports" },
          {
            id:10,
            name: "PRACTICE-REPORT",
            text: "Practice Reports",
            toRoute: "practice-report",
            sub_pages: ["response-analysis-practice"],
            hideFromDashBoard:true, 
            hideFromDrawer:true,
            requiresBoostUpModule: true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

          }
        ]
      },

      {
        label: "Customization",
        id: "ST-EDIT-PROFILE",
        name: "ST-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        hideFromDashBoard: true,
        sub_menus: [
          { text: "Customization", toRoute: "profile", hideFromDashBoard: false }
          // { id: 1, text: "Subscription Details", toRoute: "subscription-details", sub_pages:['renew-subscription','purchase-subscription'],hideFromDashBoard:false},
        ]
      },
      {
        label: "Upgrade",
        id: "ST-UPGRADE",
        icon: require("@/assets/img/svg/upgrade.svg"),
        dashBoardIcon: require("@/assets/img/svg/upgrade.svg"),
        css: "home",
        dashBoardBGColor: "upgrade-icon",
        hideFromTop: true,
        toRoute: "my-subscription",
        institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

        hideFromDashBoard:true, hideFromDrawer:true,
        sub_menus: [
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "My Subscriptions", toRoute: "my-subscription",hideFromDashBoard:true, hideFromDrawer:true },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS,text: "Unlock Boost Up", toRoute: "boost-up-upgrade",hideFromDashBoard:true, hideFromDrawer:true },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "Ready-made Tests", toRoute: "readymade-test-upgrade",hideFromDashBoard:true, hideFromDrawer:true }
        ]
      }
      // {
      //   label: "Upgrade",
      //   id: "ST-UPGRADE",
      //   icon: require("@/assets/img/svg/upgrade.svg"),
      //   dashBoardIcon: require("@/assets/img/svg/upgrade.svg"),
      //   css: "home",
      //   dashBoardBGColor: "upgrade-icon",
      //   hideFromTop: true,
      //   toRoute: "my-subscription",
      //   hasCustomMenu: true,
      //   hideFromBreadCrumb: true,
      //   sub_menus: [
      //     {
      //       //from: "",
      //       text: "My Subscriptions",
      //       toRoute: "my-subscription",
      //       hideFromDrawer: true,
      //     },
      //     {
      //       //from: "",
      //       text: "Unlock Boost Up",
      //       toRoute: "unlock-boost-up",
      //       hideFromDrawer: true,
      //     },
      //     {
      //       //from: "",
      //       text: "Ready-made Tests",
      //       toRoute: "ready-made-test",
      //       hideFromDrawer: true,
      //     },

      //     {
      //       text: "Notifications",
      //       toRoute: "notification-inbox",
      //       hideFromDashBoard: true,
      //     },
      //     { text: "Tests", toRoute: "schedule-tests", hideFromDashBoard: true },
      //     { text: "Health", toRoute: "home", hideFromDashBoard: true },
      //     {
      //       text: "Result Analysis",
      //       toRoute: "testwise-analysis",
      //       hideFromDashBoard: true,
      //     },
      //     { text: "Customization", toRoute: "profile", hideFromDashBoard: true },
      //   ],
      // },
      // {
      //   label: "Tests",
      //   css: "tests",
      //   hideFromDashBoard: true,
      //   hideFromTop: true,
      //   toRoute: "schedule-tests",
      //   sub_menus: [
      //     {
      //       text: "Scheduled Tests",
      //       toRoute: "schedule-tests",
      //       hideFromDashBoard: true,
      //     },
      //   //   {
      //   //     text: "Premium Tests",
      //   //     toRoute: "premium-test",
      //   //     hideFromDashBoard: true,
      //   //   },
      //     { text: "Past Tests", toRoute: "past-test", hideFromDashBoard: true },
      //   ],
      // },
    ],
    PARENT: [
      {
        label: "Home",
        id: "PA-HOME",
        name: "PA-HOME",
        icon: require("@/assets/img/svg/home.svg"),
        css: "home",
        toRoute: "home",
        hideFromDashBoard: true,
        showOnTop: true,
        sub_menus: [
          { text: "Notifications", toRoute: "notification-inbox" },
          { name: "ST-TEST", text: "Tests", toRoute: "live-test" },
          { text: "Health", toRoute: "my-health" },
          { text: "Result & Reports", toRoute: "testwise-analysis" },
                    { text: "Customization", toRoute: "profile" }
        ]
      },
      {
        label: "Notifications",
        id: "PA-HOME",
        name: "PA-NOTI",
        icon: require("@/assets/img/svg/notification.svg"),
        dashBoardIcon: require("@/assets/img/svg/notification.svg"),
        css: "notification",
        dashBoardBGColor: "notification-icon",
        toRoute: "notification-inbox",
        sub_menus: [
          { text: "Inbox", toRoute: "notification-inbox" },
          // { text: "Sent Items", toRoute: "notification-sent" }
        ]
      },
      {
        label: "Tests",
        id: "ST-TEST",
        name: "ST-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        dashBoardBGColor: "tests-icon",
        toRoute: "live-test",
        sub_menus: [
          { text: "Live Tests", toRoute: "live-test" },
          { text: "Upcoming Tests", toRoute: "upcoming-test" },
          {
            id:10,
            text: "Make Your Test",
            toRoute: "make-your-test",
            sub_pages: ["create-MYT-tests"]
          }
        ]
      },
      {
        label: "Health",
        id: "PA-HEALTH",
        icon: require("@/assets/img/svg/add.svg"),
        dashBoardIcon: require("@/assets/img/svg/add.svg"),
        css: "health",
        dashBoardBGColor: "health-icon",
        toRoute: "my-health",
        sub_menus: [
          {
            text: "Student Health",
            toRoute: "my-health",
            sub_pages: ["chapters-health", "topic-health"]
          },
          { text: "Leader Board", toRoute: "leaderboard" }
        ]
      },
      {
        label: "Result & Reports",
        id: "PA-RESULT-ANALYSIS",
        icon: require("@/assets/img/svg/result_analysis.svg"),
        dashBoardIcon: require("@/assets/img/svg/result_analysis.svg"),
        css: "result_analysis",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "testwise-analysis",
        sub_menus: [
          {
            text: "Test Results",
            toRoute: "testwise-analysis",
            sub_pages: [
              "testwise-analysis-coordinator",
              "cumulative-analysis-coordinator",
              "response-analysis-coordinator",
              "response-analysis"]
          },
          { text: "Cumulative Results", toRoute: "cumulative-analysis" },
          { name: "TEST-REPORT", text: "Test Reports", toRoute: "test-reports" },
          {
            id:10,
            name: "PRACTICE-REPORT",
            text: "Practice Reports",
            toRoute: "practice-report",
            sub_pages: ["response-analysis-practice"]
          }
        ]
      },
      {
        label: "Customization",
        id: "PA-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        sub_menus: [
          {
            text: "Customization",
            toRoute: "profile",
            hideFromBreadCrumb: true
          },
          { text: "Edit Info", toRoute: "profile", hideFromDrawer: true }
          // { text: "Personal Profile", toRoute: "profile", hideFromDashBoard:false},
          // { id: 1, text: "Subscription Details", toRoute: "subscription-details", sub_pages:['renew-subscription','purchase-subscription'],hideFromDashBoard:false},
        ]
      },
      {
        label: "Upgrade",
        id: "PA-UPGRADE",
        icon: require("@/assets/img/svg/upgrade.svg"),
        dashBoardIcon: require("@/assets/img/svg/upgrade.svg"),
        css: "home",
        dashBoardBGColor: "upgrade-icon",
        hideFromTop: true,
        toRoute: "my-subscription",
        hideFromDashBoard:true, hideFromDrawer:true,
        institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
        sub_menus: [
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "My Subscriptions", toRoute: "my-subscription",hideFromDashBoard:true, hideFromDrawer:true },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS,text: "Unlock Boost Up", toRoute: "boost-up-upgrade",hideFromDashBoard:true, hideFromDrawer:true },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "Ready-made Tests", toRoute: "readymade-test-upgrade",hideFromDashBoard:true, hideFromDrawer:true }
       
        ]
      }
    ],
    CUSTOMMENU: [
      {
        label: "MYT",
        id: "MYT",
        text: "Make Your Test",
        icon: require("@/assets/img/svg/myt.svg"),
        dashBoardIcon: require("@/assets/img/svg/myt.svg"),
        css: "myt",
        toRoute: "customized-tests-myt",
        dashBoardBGColor: "tests-icon",
        sub_menus: [
          // {
          //   text: "Customized Tests",
          //   toRoute: "customized-tests-myt",
          //   sub_pages: ["create-customized-tests"],
          // },
          // {
          //   text: "My Tests",
          //   toRoute: "my-tests"
          // },
        ]
      },
      {
        label: "My Tests",
        text: "My Tests",
        id: "MY-TEST",
        icon: require("@/assets/img/svg/test.svg"),
        dashBoardIcon: require("@/assets/img/svg/test.svg"),
        css: "myt-my-test",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "my-tests",
        sub_menus: [
          //   {
          //   text: "Customized Tests",
          //   toRoute: "customized-tests-myt",
          //   sub_pages: ["create-customized-tests"],
          // },
          // {
          //   text: "Customized Tests",
          //   toRoute: "my-tests",
          // },
        ]
      },
      {
        label: "My Template",
        text: "My Template",
        id: "MY-TEMPLATE",
        icon: require("@/assets/img/svg/template.svg"),
        dashBoardIcon: require("@/assets/img/svg/template.svg"),
        css: "myt-my-template",
        dashBoardBGColor: "my_template-icon",
        toRoute: "my-template",
        sub_menus: [
          //   {
          //   text: "Customized Tests",
          //   toRoute: "customized-tests-myt",
          //   sub_pages: ["create-customized-tests"],
          // },
          // {
          //   text: "Customized Tests",
          //   toRoute: "my-tests",
          // },
        ]
      }
    ],
    ONLINESTUDENT: [
      {
        label: "Home",
        id: "ST-HOME",
        name: "ST-HOME",
        icon: require("@/assets/img/svg/home.svg"),
        dashBoardIcon: require("@/assets/img/svg/home.svg"),
        css: "home",
        dashBoardBGColor: "",
        hideFromDashBoard: true,
        toRoute: "home",
        sub_menus: [
          { text: "Tests", toRoute: "live-test" },
          { text: "Results", toRoute: "pyt-test-analysis" },
          { text: "Reports", toRoute: "pyt-test-reports" },
          { name: "ST-BOOST-UP", text: "Boost Up", toRoute: "practice-session" },
          { text: "Look Back", toRoute: "attempted-questions" },
          {
            // id: "ST-UPGRADE",
            text: "Upgrade Membership",
            toRoute: "my-subscription",
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
            hideFromDashBoard:true, hideFromDrawer:true,hideFromInstitute:true
          }
        ]
      },
      {
        label: "Tests",
        id: "ST-TEST",
        name: "ST-TEST",
        icon: require("@/assets/img/svg/tests.svg"),
        dashBoardIcon: require("@/assets/img/svg/tests.svg"),
        css: "tests",
        dashBoardBGColor: "tests-icon",
        toRoute: "live-test",
        sub_menus: [
          {
            // id: "READY-MADE-TEST",
            text: "Previous Years Tests",
            toRoute: "pyt-test",
            hideFromDashBoard:true, hideFromDrawer:true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

          },
          {
            text: "A.I.T.S Tests",
            toRoute: "online-aits-test",
            hideFromDrawer: false,
            hideFromBreadCrumb: false
          },
          {
            id: 10,
            text: "Make Your Test",
            toRoute: "make-your-test",
            sub_pages: ["create-MYT-tests"],
            hideFromDashBoard:true, hideFromDrawer:true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
          },
        ]
      },
      {
        label: "Results",
        id: "ST-RESULT-ANALYSIS",
        name: "ST-RESULT-ANALYSIS",
        icon: require("@/assets/img/svg/result_analysis.svg"),
        dashBoardIcon: require("@/assets/img/svg/result_analysis.svg"),
        css: "result_analysis",
        dashBoardBGColor: "result_analysis-icon",
        toRoute: "testwise-analysis",
        sub_menus: [
          { text: "PYT Results", toRoute: "pyt-test-analysis", sub_pages: ["pyt-response-analysis-online"] },
          { text: "AITS Results", toRoute: "aits-test-analysis", sub_pages: ["aits-response-analysis-online"] },
          { text: "MYT Results", toRoute: "myt-test-analysis", sub_pages: ["myt-response-analysis-online"] },
        ]
      },
      {
        label: "Reports",
        id: "ST-REPORTS-ANALYSIS",
        name: "ST-REPORTS-ANALYSIS",
        icon: require("@/assets/img/svg/reports.svg"),
        dashBoardIcon: require("@/assets/img/svg/reports.svg"),
        css: "reports",
       dashBoardBGColor: "batches-icon",
        toRoute: "pyt-test-reports",
        sub_menus: [
          { name: "PYT-REPORT", text: "PYT Reports", toRoute: "pyt-test-reports" },
          { name: "AITS-REPORT", text: "AITS Reports", toRoute: "aits-test-reports" },
          { 
            name: "PRACTICE-REPORT", 
            text: "Practice Reports", 
            toRoute: "practice-report", 
            sub_pages: ["response-analysis-practice", "practice-session"],
            hideFromDashBoard:true, 
            hideFromDrawer:true,
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS, },
          { name: "ONLINE-CHAPTER-STANDING", text: "Chapterwise Standing", toRoute: "online-chapter-standing" },
        ]
      },
      {
        label: "Boost Up",
        id: "ST-BOOST-UP",
        name: "ST-BOOST-UP",
        icon: require("@/assets/img/svg/boost-icon.svg"),
        dashBoardIcon: require("@/assets/img/svg/boost-icon.svg"),
        css: "boost",
        dashBoardBGColor: "boost-icon",
        toRoute: "make-your-test",
        sub_menus: [
          {
            id: 10,
            text: "Practice Session",
            toRoute: "practice-session",
            sub_pages: [],
            institute_ids: process.env.VUE_APP_INSTITUTE_IDS,
            hideFromDashBoard:true, hideFromDrawer:true
          },
          {
            text: "A(I)ssignments",
            toRoute: "improvement-assignments"
          },
        ]
      },
      {
        label: "Look Back",
        id: "ST-LOOK-BACK",
        name: "ST-LOOK-BACK",
        icon: require("@/assets/img/svg/look-back.svg"),
        dashBoardIcon: require("@/assets/img/svg/look-back.svg"),
        css: "look_back",
        dashBoardBGColor: "look_back-icon",
        toRoute: "attempted-questions",
        sub_menus: [
          {
            name: "ATTEMPTED-QUESTIONS",
            text: "Attempted Questions",
            toRoute: "attempted-questions"
          },
          { text: "Past Tests", toRoute: "online-past-test" },
          { text: "Bookmarked Questions", toRoute: "bookmarked-questions" }
        ]
      },
      {
        label: "Customization",
        id: "ST-EDIT-PROFILE",
        name: "ST-EDIT-PROFILE",
        icon: require("@/assets/img/svg/profile.svg"),
        dashBoardIcon: require("@/assets/img/svg/profile.svg"),
        css: "home",
        dashBoardBGColor: "profile-icon",
        toRoute: "profile",
        hideFromTop: true,
        hideFromDashBoard: true,
        sub_menus: [
          { text: "Customization", toRoute: "profile", hideFromDashBoard: false }
          // { id: 1, text: "Subscription Details", toRoute: "subscription-details", sub_pages:['renew-subscription','purchase-subscription'],hideFromDashBoard:false},
        ]
      },
      {
        label: "Upgrade",
        id: "ST-UPGRADE",
        icon: require("@/assets/img/svg/upgrade.svg"),
        dashBoardIcon: require("@/assets/img/svg/upgrade.svg"),
        css: "home",
        dashBoardBGColor: "upgrade-icon",
        hideFromTop: true,
        toRoute: "my-subscription",
        institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

        hideFromDashBoard:false, hideFromDrawer:false,
        sub_menus: [
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "My Subscriptions", toRoute: "my-subscription",hideFromDashBoard:false, hideFromDrawer:false },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS,text: "Master PYQs", toRoute: "masterpyq-upgrade",hideFromDashBoard:false, hideFromDrawer:false },
          { institute_ids: process.env.VUE_APP_INSTITUTE_IDS, text: "A.I.T.S", toRoute: "readymade-test-upgrade",hideFromDashBoard:false, hideFromDrawer:false }
        ]
      }
    ],
  }
};